import { render, staticRenderFns } from "./client-details.vue?vue&type=template&id=8efa03b8&scoped=true&"
import script from "./client-details.vue?vue&type=script&lang=js&"
export * from "./client-details.vue?vue&type=script&lang=js&"
import style0 from "./client-details.vue?vue&type=style&index=0&id=8efa03b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8efa03b8",
  null
  
)

export default component.exports